import { Widgets } from "@libs/utilities"
import LayoutHeaderHeader from "../LayoutHeaderHeader"
import LayoutHeaderMenu from "../LayoutHeaderMenu"
import LayoutUser from "./LayoutUser"
import { useEffect, useState } from "react"
import { WINDOW_WIDTH } from "@libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface ILayoutHeaderScreenProps {
   
}
const LayoutHeaderScreen = (props: ILayoutHeaderScreenProps): JSX.Element => { 
    const [isHumburger, ] = useState(false)
    const [, setMobile] = useState( window.innerWidth < WINDOW_WIDTH.TABLET ) 
    useEffect(() => {
        const onResizeHandler = () => {
            setMobile( window.innerWidth < WINDOW_WIDTH.TABLET )
        }
        window.addEventListener("resize", onResizeHandler)
        return () => window.removeEventListener("resize", onResizeHandler)
    }, [])
    const onHumburger = () => {

    } 
    
    return <div className="layout-header" id="layout-header" data-testid="layout-header-cont">
        <div className="layout-header-left"data-testid="layout-header-left">
            <LayoutHeaderHeader />
        </div>
        <Widgets areaName="layout-header-center" data={{...props}} /> 
        <div className={`d-flex-menu ${ isHumburger ? "open" : ""}`}>
            <LayoutHeaderMenu onHumburger={ onHumburger}  />
        </div>
        <div
            className={`layout-menu-right ${ isHumburger ? "open" : ""}`}
            id="layout-menu-right"
            data-testid="layout-header-right"
        >
            <LayoutUser isOpen={false} />
        </div>
    </div>
}
export default LayoutHeaderScreen